import { render, staticRenderFns } from "./BillingStatusColumn.vue?vue&type=template&id=16fdc9ae&"
import script from "./BillingStatusColumn.vue?vue&type=script&lang=js&"
export * from "./BillingStatusColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports